import "../pages/PatientDetails.scss";
import { useEffect, useRef, useState } from "react";
import NoPainImage from "../assets/images/NoPainImage.svg";
import MildPainImage from "../assets/images/MildPainImage.svg";
import ModeratePainImage from "../assets/images/ModeratePainImage.svg";
import SeverePainImage from "../assets/images/SeverePainImage.svg";
import NAImage from "../assets/images/NotApplicable.svg";
import LineChart from "./LineChart";
import PainChart from "./PainChart";
import patientHistoryData from "../localDB/patientHistory.json";
import CSVExportButton from "./CSVGenerator";
import PDFExportButton from "./PDFExportButton";

const PatientHistory = ({ patientHistory, setSelectedTab }) => {
  const [painCharts, setPainCharts] = useState({
    leftHip: true,
    leftKnee: true,
    leftAnkle: true,
  });
  // const [patientHistory, setPatientHistory] = useState(patientHistoryData);
  // console.log("Patient History: ", patientHistory);
  const [loadedImages, setLoadedImages] = useState({});
  const peakForceHistory = useRef();
  const averageForceHistory = useRef();
  const dateFormat = (date) => {
    return new Date(date).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };
  useEffect(() => {
    console.log("Inside history component ", patientHistory);
    // Preload images with promises
    const images = {};
    const loadImage = (name, src) => {
      return new Promise((resolve) => {
        const img = new Image(30, 30);
        img.src = src;
        img.onload = () => {
          images[name] = img;
          resolve();
        };
      });
    };

    Promise.all([
      loadImage("4", NAImage),
      loadImage("3", NoPainImage),
      loadImage("2", MildPainImage),
      loadImage("1", ModeratePainImage),
      loadImage("0", SeverePainImage),
    ]).then(() => setLoadedImages(images)); // Set loaded images after all promises resolve
  }, []);
  return patientHistory?.history?.length > 0 ? (
    <div style={{ marginLeft: "1.5rem" }}>
      <div className="row" style={{ justifyContent: "flex-end" }}>
        <CSVExportButton type="history" sessionData={patientHistory} />

        <PDFExportButton
          chartRefs={[peakForceHistory, averageForceHistory]}
          type="history"
          sessionData={patientHistory}
        />
      </div>
      <div
        ref={peakForceHistory}
        style={{
          padding: "1.75rem 2.8rem",
          borderRadius: "0.75rem",
          border: "1px solid var(--midGray)",
          background: "var(--white)",
          width: "75%",
          margin: "1rem",
        }}
      >
        <div className="h2">Peak Force Over time</div>
        <div className="b2">Force vs Time</div>
        <div>
          <LineChart
            labels={[
              ...Object.keys(patientHistory.history).map((date) =>
                dateFormat(date)
              ),
            ]}
            leftData={[
              ...Object.values(patientHistory.history).map(
                (info) => info.peakLeftForce
              ),
            ]}
            rightData={[
              ...Object.values(patientHistory.history).map(
                (info) => info.peakRightForce
              ),
            ]}
          />
        </div>
      </div>

      {/* <div
        ref={averageForceHistory}
        style={{
          padding: "1.75rem 2.8rem",
          borderRadius: "0.75rem",
          border: "1px solid var(--midGray)",
          background: "var(--white)",
          width: "75%",
          margin: "1rem",
        }}
      >
        <div className="h2">Average Force Over time</div>
        <div className="b2">Force vs Time</div>
        <div>
          <LineChart
            labels={[
              ...Object.keys(patientHistory.history).map((date) =>
                dateFormat(date)
              ),
            ]}
            leftData={[
              ...Object.values(patientHistory.history).map(
                (info) => info.avgLeftForce
              ),
            ]}
            rightData={[
              ...Object.values(patientHistory.history).map(
                (info) => info.avgRightForce
              ),
            ]}
          />
        </div>
      </div> */}
      <div>
        <div
          style={{
            width: "75%",
            margin: "1rem",
          }}
        >
          <div className="h2" style={{ marginBottom: "0.62rem" }}>
            Pain History
          </div>
          <div
            className="grid"
            style={{
              gridTemplateColumns: "1fr 1fr",
              columnGap: "3.7rem",
              rowGap: "1.31rem",
            }}
          >
            <div
              style={{
                borderRadius: "0.5rem",
                border: "1px solid #979797",
                padding: "0.69rem",
              }}
            >
              <div className="painChartRadio">
                <input
                  type="radio"
                  name="hipChart"
                  id="leftHipChart"
                  value="Left Hip"
                  defaultChecked={true}
                  onChange={() =>
                    setPainCharts((prevState) => ({
                      ...prevState,
                      leftHip: true,
                    }))
                  }
                />
                <label htmlFor="leftHipChart">Left Hip</label>
                <input
                  type="radio"
                  name="hipChart"
                  id="rightHipChart"
                  value="Right Hip"
                  onChange={() =>
                    setPainCharts((prevState) => ({
                      ...prevState,
                      leftHip: false,
                    }))
                  }
                />
                <label htmlFor="rightHipChart">Right Hip</label>
              </div>
              <div>
                <PainChart
                  labels={[
                    ...Object.keys(patientHistory.history).map((date) =>
                      dateFormat(date)
                    ),
                  ]}
                  painData={[
                    ...Object.values(patientHistory.history).map((info) =>
                      painCharts["leftHip"] ? info.leftHip : info.rightHip
                    ),
                  ]}
                  loadedImages={loadedImages}
                />
              </div>
            </div>
            <div
              style={{
                borderRadius: "0.5rem",
                border: "1px solid #979797",
                padding: "0.69rem",
              }}
            >
              <div className="painChartRadio">
                <input
                  type="radio"
                  name="kneeChart"
                  id="leftKneeChart"
                  value="Left Knee"
                  defaultChecked={true}
                  onChange={() =>
                    setPainCharts((prevState) => ({
                      ...prevState,
                      leftKnee: true,
                    }))
                  }
                />
                <label htmlFor="leftKneeChart">Left Knee</label>
                <input
                  type="radio"
                  name="kneeChart"
                  id="rightKneeChart"
                  value="Right Knee"
                  onChange={() =>
                    setPainCharts((prevState) => ({
                      ...prevState,
                      leftKnee: false,
                    }))
                  }
                />
                <label htmlFor="rightKneeChart">Right Knee</label>
              </div>
              <div>
                <PainChart
                  labels={[
                    ...Object.keys(patientHistory.history).map((date) =>
                      dateFormat(date)
                    ),
                  ]}
                  painData={[
                    ...Object.values(patientHistory.history).map((info) =>
                      painCharts["leftKnee"] ? info.leftKnee : info.rightKnee
                    ),
                  ]}
                  loadedImages={loadedImages}
                />
              </div>
            </div>
            <div
              style={{
                borderRadius: "0.5rem",
                border: "1px solid #979797",
                padding: "0.69rem",
              }}
            >
              <div className="painChartRadio">
                <input
                  type="radio"
                  name="ankleChart"
                  id="leftAnkleChart"
                  value="Left Ankle"
                  defaultChecked={true}
                  onChange={() =>
                    setPainCharts((prevState) => ({
                      ...prevState,
                      leftAnkle: true,
                    }))
                  }
                />
                <label htmlFor="leftAnkleChart">Left Ankle</label>
                <input
                  type="radio"
                  name="ankleChart"
                  id="rightAnkleChart"
                  value="Right Ankle"
                  onChange={() =>
                    setPainCharts((prevState) => ({
                      ...prevState,
                      leftAnkle: false,
                    }))
                  }
                />
                <label htmlFor="rightAnkleChart">Right Ankle</label>
              </div>
              <div>
                <PainChart
                  labels={[
                    ...Object.keys(patientHistory.history).map((date) =>
                      dateFormat(date)
                    ),
                  ]}
                  painData={[
                    ...Object.values(patientHistory.history).map((info) =>
                      painCharts["leftAnkle"] ? info.leftAnkle : info.rightAnkle
                    ),
                  ]}
                  loadedImages={loadedImages}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div
      className="h2 textCenter row"
      style={{ margin: "1.5rem", justifyContent: "center" }}
    >
      You have no previous
      {/* <button
        className="icon-buttons h2 hippiBlue"
        onClick={() => setSelectedTab("Sessions")}
      > */}
      sessions
      {/* </button> */}
    </div>
  );
};
export default PatientHistory;
